/**
 * Canonical HiiKER gold for the elevation-panel-v2 chart line — the fallback
 * colour used when there's no meaningful surface data to colour it by (e.g.
 * recordings), so it is a single named constant here rather than scattered
 * literals, making a future brand-colour swap (see the elevation-panel-v2
 * plan's Open Questions on `#FFDF46` vs `#F5C518`) a one-line change.
 */
export const ELEVATION_LINE_COLOR = '#FFDF46';
